import { useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useAuthenticateMerchantUser() {
    const source = axios.CancelToken.source();

    const [merchantToken, setMerchantToken] = useState<string | undefined>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const authenticateMerchantUser = async () => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.authenticateMerchantUser(source);
        setMerchantToken(res.MerchantUserToken);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };
    const reset = () => {
      setMerchantToken(undefined);
    };

    return {
      merchantToken,
      authenticateMerchantUser,
      reset,
    };
  };
});

export default initHook({});
